import React from 'react';
import {createRefetchContainer, graphql} from 'react-relay';
import PropTypes from 'prop-types';
import { source } from 'react-aim';
import UserMenuList from './UserMenuList';
import Counter from './Counter';
import LoginLink from './LoginLink';
import TdWebService from '../service/TdWebService';

@source({
  mouseEnter: (props, component) => component.setState({ over: true }),
  mouseLeave: (props, component) => component.setState({ over: false })
})
class UserMenu extends React.Component {

  static propTypes = {
    viewer: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = { over: false };
  }

  render() {

    let {
      viewer
    } = this.props;

    let {
      over
    } = this.state;

    //console.log('UserMenu', viewer, over);

    let iconClassName = 'login';
    let image;
    let userMenuList;
    if (viewer && viewer.isLogin) {

      TdWebService.setMemberId(viewer.userId);

      if (over) {
        userMenuList = <UserMenuList viewer={viewer} />
      }

      iconClassName = 'user';
      if (viewer.isBusiness) {
        iconClassName = 'userbiz';
      }

      image = <div className={`util-icon ${iconClassName}`} />;

    } else {

      image = <LoginLink />

    }

    return (
      <div id="userMenu">
        {image}
        {viewer && viewer.unreadMessageCount>0 && <Counter top={true} count={viewer.unreadMessageCount}/>}
        {userMenuList}
      </div>
    )
  }

}

export default createRefetchContainer(UserMenu, {
    viewer: graphql`
        fragment UserMenu_viewer on Viewer {
            userId
            locale
            serverTime
            displayName
            companyName
            isLogin
            isBusiness
            isActiveBusiness
            buyer {
                approvalFlag
            }
            unreadMessageCount
        }
    `}
  , graphql`
            query UserMenuRefetchQuery {
                viewer {
                    ...UserMenu_viewer
                }
            }
  `
);